import React from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";


export default function RecoverPasswordSuccess() {

    
  return (
    <div className="auth-fluid">
      <div className="auth-fluid-form-box">
        <div className="align-items-center d-flex h-100">
          <div className="card-body">


            <div className="auth-brand text-center text-lg-start">
              <a href="index.html" classNameName="logo-dark">
                <span><img src="content/theme/assets/images/asniclogo.png" alt="" style={{ "height": 50 }} /></span>
              </a>
            </div>

            <h4 className="mt-0">Success</h4>
            <p className="text-muted mb-4">Password reset request was sent successfully. Please check your email to reset your password</p>



            <footer className="footer footer-alt">
              <p className="text-muted">Back to <a href="/login" className="text-muted ms-1"><b>Log In</b></a></p>
            </footer>

          </div>
        </div>
      </div>
    </div>
  )
}
